module.exports = __webpack_public_path__ + "img/the-one-ring-icon-17.368e99ef.jpeg";